import {ImageObject} from "../../contenful/types";
import {Link} from "react-router-dom";
import {prettyUrl} from "../../utils/UrlUtils";
import React from "react";

export interface GameSliderItemProps {
    name: string;
    backgroundImage: ImageObject;
    logoImage?: ImageObject;
    gameId: string;
}

export const GameSliderItem = (props: GameSliderItemProps) => {
    const launchUrl = `/casino/play/${props.gameId ?? ""}/${prettyUrl(`${props.name ? props.name : ''}`)}/auto`;
    const logoImageURL = props.logoImage?.fields.file.url;
    return (
        <Link to={launchUrl} className={'card-wrapper play-button'}>
            <div className="card-game-list">
                <img src={props.backgroundImage.fields.file.url} className={"bg"} alt={props.name || ''}/>
                {logoImageURL &&
                    <div className="card-inner">
                        <img src={logoImageURL} className="logo" alt={props.name || ''}/>
                    </div>
                }
            </div>
            <div className="card-game-name">
                <p className="name">
                    {props.name}
                </p>
            </div>
        </Link>
    )
}